import { STATS } from "@/data/portfolio";

export default function Stats() {
  return (
    <section data-testid="stats-section" className="border-b border-white/10 py-10 md:py-14">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-2 md:grid-cols-4">
        {STATS.map((s, i) => (
          <div
            key={s.label}
            data-testid={`stat-${i}`}
            className={`reveal py-6 ${i !== 0 ? "md:border-l border-white/10 md:pl-10" : ""} ${
              i % 2 === 1 ? "border-l md:border-l border-white/10 pl-6 md:pl-10" : ""
            }`}
            style={{ transitionDelay: `${i * 80}ms` }}
          >
            <p className="font-oswald text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-white">
              {s.value}
            </p>
            <p className="mt-2 font-manrope text-xs md:text-sm uppercase tracking-widest text-white/50">
              {s.label}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
